import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      productiveTimes: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Qtd. Etapas',
          align: 'center',
          value: 'quantityStep',
        },
        {
          text: 'Tempo Etapas',
          align: 'center',
          value: 'timeStep',
        },
        {
          text: 'Qtd Tarefas',
          align: 'center',
          value: 'quantityTask',
        },
        {
          text: 'Tempo Tarefas',
          align: 'center',
          value: 'timeTask',
        },
        {
          text: 'Tempo Total',
          align: 'center',
          value: 'totalTime',
        },
      ],
      mobileHeader: [
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Tempo Total',
          align: 'center',
          value: 'totalTime',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listProductiveTime()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `Productive_Time_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/productiveTime', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listProductiveTime() {
      this.loading = true
      await this.apiService
        .post('reports/productiveTime', this.filterProp)
        .then((response) => {
          this.total = response.content.total
          this.productiveTimes = response.content.paged.objects
          this.showChart = response.content.paged.objects.length > 0
          this.totalPages = response.content.paged.pager.totalPages
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listProductiveTime()
    },
  },
}
